import { inject, observer } from "mobx-react";
import React from "react";
import { Button, Card, CardBody, CardFooter, Col, Modal, ModalBody, ModalFooter, ModalHeader, Row, Spinner } from "reactstrap";
import notAuthImg from "../../assets/img/pages/not-authorized.png";
import "../../assets/scss/pages/app-chat.scss";
import UserControls from "./components/UserControls";
const mql = window.matchMedia(`(min-width: 992px)`);
import CanvasDraw from "react-canvas-draw";

@inject("publicMeetingStore", "sessionStore")
@observer
class PublicMeetingRoom extends React.Component {
  state = {
    showJoinModal: false,
    width: innerWidth,
    height: parseInt(innerWidth*(0.5714)) > innerHeight ? innerHeight : parseInt(innerWidth*(0.5714)) 
  };

  componentDidMount() {
    window.addEventListener("resize", this.updateDimensions);
    const { publicMeetingStore, match  } = this.props;
    const { sharecode, medium } = match.params;
    publicMeetingStore.getMeeting(sharecode, medium);
  }

  UNSAFE_componentWillMount() {
    // mql.addListener(this.mediaQueryChanged)
  }

  componentWillUnmount() {
    //mql.removeListener(this.mediaQueryChanged)
    window.removeEventListener("resize", this.updateDimensions)
  }

  mediaQueryChanged = () => {
    //this.setState({ sidebarDocked: mql.matches, sidebarOpen: false })
  };

  showJoinMeeting = () => {
    // const { publicMeetingStore } = this.props;
    // if (publicMeetingStore.meeting.useAudio) {
    //   this.setState((prevState) => ({
    //     showJoinModal: true,
    //   }));
    // } else {
    //   this.joinMeeting();
    // }
    this.setState((prevState) => ({
      showJoinModal: false,
    }));
  };

  joinMeeting = () => {
    const { publicMeetingStore} = this.props;
    publicMeetingStore.joinMeeting();
    this.setState({ showJoinModal: false });
  };

  loadCanvasData = (data) => {
    if (this.loadableCanvas){
      this.loadableCanvas.loadSaveData(data, false);
    }
  }

  updateDimensions = async () => {
    this.setState({
      width: innerWidth,
      height: parseInt(innerWidth*(4/7)) > innerHeight ? innerHeight : innerWidth*(4/7)
    })
  } 

  render() {
    const { publicMeetingStore } = this.props;
    const { showJoinModal } = this.state;
    const { meeting } = publicMeetingStore;

    if (meeting.status === "STARTED"){
      this.loadCanvasData(meeting.canvasData);
    }
    
    const waitingMessage = (
      <div className="public-meeting-room">
        <div className="no-message">
          <span className="center-button">
            <div className="button-container">
              <span className="pulse-button">Waiting</span>
            </div>
          </span>
        </div>
      </div>
    );

    const imageUrl = "https://i.ibb.co/zP5HFVp/branding.png";

    const landingMessage = (
      <div className="public-meeting-room">
        <img src="https://i.ibb.co/zP5HFVp/branding.png" width="100%"></img>
      </div>
    );

    const joinModal = (
      <Modal isOpen={this.state.showJoinModal} toggle={this.showJoinMeeting}>
        <ModalHeader toggle={this.showJoinMeeting}>Join Meeting</ModalHeader>
        <ModalBody>
          <p>You will be connected to audio.</p>
          <p>Please click "Continue"</p>
          {/* <Checkbox
              color="primary"
              icon={<Check className="vx-icon" size={16} />}
              label="Join Computer Audio"
              defaultChecked={false}
              value={this.state.audioOpted}
              onClick={e=> this.setState({audioOpted: true})} /> */}
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={this.joinMeeting}>
            Continue
          </Button>
        </ModalFooter>
      </Modal>
    );

    const thankyouMessage = (
      <Row className="m-0">
        <Col sm="12">
          <Card className="auth-card bg-transparent shadow-none rounded-0 mb-0 w-100">
            <CardBody className="text-center">
              <img
                src={notAuthImg}
                alt="notAuthImg"
                className="img-fluid align-self-center mt-75"
              />
              <h1 className="font-large-2 my-2">Thank You!!</h1>
              <p className="pt-2 mb-0">
                Thanks for Attending. Meeting is Over!!
              </p>
              <p className="pb-2">
                To download the Presentation. Click the download button.
              </p>
              <Button
                href={meeting.presentation.docUrl} 
                color="primary"
                size="lg"
                className="mt-2"
              >
                Download
              </Button>
            </CardBody>
          </Card>
        </Col>
      </Row>
    )

    const joinComponent = (
      <div>
        {
          meeting.status == "END" ? 
              ( <div>
                  { thankyouMessage }
               </div>
              ) : (
                  meeting.status !== "STARTED" && meeting.participants[0].displayName 
                  ? (
                    <CardFooter>
                      <div className="profile-header">
                        <div className="profile-img-container display-inline width-40p">
                          <img
                            src={
                              meeting.presenter.imageUrl === ""
                                ? "https://www.evolutionsociety.org/userdata/news_picupload/pic_sid189-0-norm.jpg"
                                : meeting.presenter.imageUrl
                            }
                            alt="porfileImg"
                            className="img-fluid img-border rounded-circle box-shadow-1 mb-2 height-120"
                          />
                          
                        </div>
                        <div className="display-inline-block mt-10p ml-20 width-60p">
                            <b>
                              Thanks for Joining.{" "}
                              {meeting.participants[0].displayName.split(" ")[0]}!!
                            </b>
                            <br />
                            <b>
                              {meeting.presenter.displayName} will be Joining soon!
                            </b>
                            <br />
                            <Button color="primary" className="mt-2">
                              <Spinner color="white" size="sm" />
                              <span className="ml-50">Waiting...</span>
                            </Button>
                        </div>
                      </div>
                    </CardFooter>
                  ) : null
              )
        }
      </div>
    );
    
    let presentationSlide = null;
    if (meeting) {
      // if (meeting.participants[0].status == "OFFLINE") {
      //   presentationSlide = waitingMessage;
      // }
      // else 
      // if (meeting.status === "SCHEDULED" && meeting.participants[0].status == "ONLINE") {
      if (meeting.status !== "END" && meeting.status !== "STARTED") {
        presentationSlide = waitingMessage;
      }
      else if (meeting.status === "STARTED") {
        const slide =
          meeting.presentation.slides[meeting.presentation.currentSlide];
        presentationSlide = (
          <div className="slide">
            <CanvasDraw 
              className={`img-fluid ${
                slide.animate ? `animated ${slide.animate}` : ""
                }`}
              disabled
              hideGrid
              ref={canvasDraw => (this.loadableCanvas = canvasDraw)}
              imgSrc={slide.content}
              canvasWidth={this.state.width}
              canvasHeight={this.state.height}
            />
          </div>
        );
      }
    } else {
      presentationSlide = noMeeting;
    }
    
    return (
      <React.Fragment>
        {showJoinModal ? joinModal : null}
        <div className="public-meeting-room">
          <div>{presentationSlide}</div>
          <Col xs="12" className="padding-0">
            {joinComponent}
          </Col>
        </div>
      </React.Fragment>
    );
  }
}

export default PublicMeetingRoom;
